import { AdvancedSearchFilterGroupView } from "./advanced-search-filter-group";
import { AdvancedSearchFilterGroupModel } from "./../../models/advanced-search-filter-group";
import {backboneViewProperties} from "../../../decorators/backbone-properties";
import {AdvancedSearchFilterView} from "../../../search/views/advanced-search/advanced-search-filter";
import {AdvancedSearchFilterModel} from "../../../search/models/advanced-search-filter";

@backboneViewProperties({
    tagName: "div",
    childView : AdvancedSearchFilterGroupView
})
export class AdvancedSearchFilterGroupsView extends Marionette.CollectionView<AdvancedSearchFilterGroupModel, AdvancedSearchFilterGroupView> {
    constructor(options?: Marionette.CollectionViewOptions<AdvancedSearchFilterGroupModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-filter-groups.ts